
export const generateCsvTemplate = () => {
  const headers = ['email', 'first_name', 'last_name', 'role'];
  const sampleData = [
    'john.doe@example.com,John,Doe,member',
    'jane.smith@example.com,Jane,Smith,superadmin',
    'coach.wilson@example.com,Mike,Wilson,member'
  ];
  
  const csvContent = [headers.join(','), ...sampleData].join('\n');
  
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', 'user_import_template.csv');
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Export for testing purposes
export const generateCSVTemplate = () => {
  const headers = ['first_name', 'last_name', 'email', 'role', 'organization'];
  const sampleData = [
    'John,Doe,john.doe@example.com,coach,Test Organization',
    'Jane,Smith,jane.smith@example.com,player,Test Organization',
    'Mike,Johnson,mike.johnson@example.com,parent,Test Organization'
  ];
  
  return [headers.join(','), ...sampleData].join('\n');
};

export const validateCsvFile = (file: File): { isValid: boolean; error?: string } => {
  const maxSize = 100 * 1024; // 100KB
  
  if (!file.name.toLowerCase().endsWith('.csv')) {
    return { isValid: false, error: 'Please select a CSV file' };
  }
  
  if (file.size > maxSize) {
    return { isValid: false, error: `File size exceeds ${maxSize / 1024}KB limit` };
  }
  
  if (file.size === 0) {
    return { isValid: false, error: 'File appears to be empty' };
  }
  
  return { isValid: true };
};
